import { SmsCodeForm } from "@/entities/sms-code-form";
import { useSmsCodeForm } from "@/features/password-recovery/model/hooks";

export const SmsCodeStep = () => {
  const props = useSmsCodeForm();

  return <SmsCodeForm {...props} />;
};
